export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
export const dt = (d) =>
  d ? new Date(d).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "-";
export const errMsg = (e) => e?.response?.data?.message || e?.message || "Something went wrong";
